import API from './api';

let instance = null;
const api = new API();
const URL_GET_NAVIGATION = '/api/users/self/navigation';

export default class NavigationService {
    constructor() {
        if (!instance) {
            instance = this;
        }
        return instance;
    }

    getNavigation({ cache = true } = {}) {
        return new Promise((resolve, reject) => {
            api.getJson(URL_GET_NAVIGATION, {
                method: 'GET',
                credentials: 'include',
                params: {},
                cache,
                forceRefresh: !cache,
            })
                .then(response => {
                    if (response.status) {
                        return reject(response.value);
                    }
                    return resolve(response.value);
                })
                .catch(reject);
        });
    }
}
